import api from '@/modules/api.service';
import { EnumerateDefensores } from '@/modules/people/defensor.service';
import { ReadDefensorResponseDto } from '@/api.types';

export async function buscarDefensorPorCpfUseCase(cpf: string): Promise<ReadDefensorResponseDto | null> {
  try {
    const response = await api.get(`/defensor/by-cpf/${cpf}`);
    return response.data || null;
  } catch (error) {
    console.error('Erro ao buscar defensor por CPF (novo endpoint):', error);

    try {
      const response = await EnumerateDefensores(0, 1, false, true, 'nome', true, '', cpf);

      if (response && response.objects && response.objects.length > 0) {
        return response.objects[0];
      }
      return null;
    } catch (fallbackError) {
      console.error('Erro ao buscar defensor por CPF (fallback):', fallbackError);
      return null;
    }
  }
}
